import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let routes=[
  {
    path: '/',
    redirect: {
      name: 'login',
    },
    component: () => import('@/components/login/login.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/components/login/login.vue'),

  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/components/home/home.vue'),
    children:[
      {
        path: '/',
        component: () => import('@/components/choice/choice.vue'),
      },
      {
        path: 'choice',
        component: () => import('@/components/choice/choice.vue'),
      },
      {
        path: 'seatProduct',
        component: () => import('@/components/seatProduct/seatProduct.vue'),
      },
      {
        path: 'record',
        component: () => import('@/components/record/record.vue'),
      },
      {
        path: 'personal',
        component: () => import('@/components/personal/personal.vue'),
      },
      {
        path: 'ranking',
        component: () => import('@/components/ranking/ranking.vue'),
      },
    ]

  },
]
const router =  new Router({
  // mode:"history",
  linkActiveClass:'active',
  routes
})


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js